const EXPORT_TYPES = {
  SERVICE_JOBS: 'JOBS',
};

const exportTypeOptions = [
  {
    value: EXPORT_TYPES.SERVICE_JOBS,
    label: 'Jobs',
  },
];

export { EXPORT_TYPES, exportTypeOptions };
